import gsap from 'gsap';
import { generateJersey } from '../../common/api';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class AvatarSelection {
  constructor() {
    document
      .querySelector('#avatar_screen .selection #male')
      .addEventListener('click', this.selectAvatar.bind(this, 'Male'));
    document
      .querySelector('#avatar_screen #female')
      .addEventListener('click', this.selectAvatar.bind(this, 'Female'));

    document
      .querySelector('#startGameBtn')
      .addEventListener('click', this.onProceed.bind(this));

    document
      .querySelector('#avatar_screen #name')
      .addEventListener('keyup', this.saveAvatarName.bind(this));
  }
  init() {
    this.isValidAge = false;
    this.errorTO = null;
    this.isProcessing = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  async showScreen(data) {
    if (data['screenKey'] !== 'ShowAvatarSelection') return false;

    document.querySelector('#avatar_screen').classList.add('active');
    gsap.delayedCall(0.1, () => {
      document.querySelector('#avatar_screen').classList.add('active2');
    });

    document.querySelector('#avatar_screen #name').value =
      Global.userName.slice(0, 7);
    Global.avatarName = document
      .querySelector('#avatar_screen #name')
      .value.trim();
    this.animateScreen();

    // Global.gender = 'Male';
    // Global.avatarName = 'lampard';
    // this.createJerseyAndProceed();
  }
  animateScreen() {
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#avatar_screen .contents .title')
        .classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document
        .querySelector('#avatar_screen .contents .option:nth-child(1)')
        .classList.add('active2');
      document
        .querySelector('#avatar_screen .contents .option:nth-child(1)')
        .classList.add('active3');
    });
    gsap.delayedCall(0.3, () => {
      document
        .querySelector('#avatar_screen .contents .option:nth-child(2)')
        .classList.add('active2');
      document
        .querySelector('#avatar_screen .contents .option:nth-child(2)')
        .classList.add('active3');
    });
    gsap.delayedCall(0.4, () => {
      document
        .querySelector('#avatar_screen .contents .name_title')
        .classList.add('active');
    });
    gsap.delayedCall(0.5, () => {
      document
        .querySelector('#avatar_screen .contents .field')
        .classList.add('active');
    });
    gsap.delayedCall(0.6, () => {
      document
        .querySelector('#avatar_screen .contents .btn_container')
        .classList.add('active');
    });
    gsap.delayedCall(0.7, () => {
      document.querySelector('#avatar_screen .footer').classList.add('active');
    });
  }
  saveAvatarName() {
    Global.avatarName = document
      .querySelector('#avatar_screen #name')
      .value.trim();
  }
  selectAvatar(gender) {
    if (this.isProcessing) return;
    Global.gender = gender;

    document
      .querySelector('#avatar_screen .contents .option:nth-child(1)')
      .classList.remove('active3');
    document
      .querySelector('#avatar_screen .contents .option:nth-child(2)')
      .classList.remove('active3');

    document.querySelector('#avatar_screen #male').classList.remove('active');
    document.querySelector('#avatar_screen #female').classList.remove('active');
    document
      .querySelector(`#avatar_screen #${gender.toLowerCase()}`)
      .classList.add('active');
  }
  async onProceed() {
    if (this.isProcessing) return;
    let isValid = true;
    if (Global.gender == null) {
      document.querySelector('.errorSec').innerHTML = 'Select Your Avatar';
      isValid = false;
    }
    if (
      (Global.avatarName == null || Global.avatarName.length == 0) &&
      isValid
    ) {
      document.querySelector('.errorSec').innerHTML = 'Select Your Name';
      isValid = false;
    }
    this.errorTO && clearTimeout(this.errorTO);
    if (!isValid) {
      document.querySelector('.errorSec').classList.add('active');

      this.errorTO = setTimeout(() => {
        document.querySelector('.errorSec').classList.remove('active');
      }, 1000);
    } else {
      document.querySelector('.errorSec').classList.remove('active');
      this.isProcessing = true;
      document.querySelector('#avatar_screen #name').disabled = true;
      this.createJerseyAndProceed();
    }
  }
  async onJerseyPrinted(data) {
    const _jersey = await Global.textureLoader.loadAsync(
      `${Global.BASE_URL}${data['file']}`
    );
    Global.assets['textures']['jersey'] = {
      key: 'jersey',
      asset: _jersey,
    };
    this.events.dispatchEvent({
      type: 'PLAYER_EVENTS',
      message: {
        event_type: 'update_keeper_jersey',
        data: {},
      },
    });
    gsap.delayedCall(0.3, () => {
      this.hideScreen();

      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'init_scene',
          data: {},
        },
      });

      gsap.delayedCall(0.2, () => {
        this.events.dispatchEvent({
          type: 'CAMERA_EVENTS',
          message: {
            event_type: 'add_intro_view',
            data: {},
          },
        });
        this.events.dispatchEvent({
          type: 'GAMESCENE_EVENTS',
          message: {
            event_type: 'update_post_feature',
            data: {},
          },
        });
      });
    });
  }
  createJerseyAndProceed() {
    document.querySelector('#startGameBtn').innerHTML = 'PLEASE WAIT...';

    Global.userName = Global.avatarName;
    Global.mobile = '123';

    Global.serverObj.send(Global.URL_DATA, null, null, {
      saveType: 'register',
      name: Global.avatarName,
      mobile: '123',
      // email: Global.email,
      // location: Global.location,
      // IGhandle: Global.IGHandle,
      uniqID: Global.U_ID,
    });

    Global.serverObj.send(
      Global.URL_JERSEY,
      this.onJerseyPrinted.bind(this),
      null,
      {
        playerName: Global.avatarName.toUpperCase(),
        uniqID: Global.U_ID,
        gender: Global.gender,
      }
    );
  }

  hideScreen() {
    document.querySelector('#avatar_screen').classList.remove('active');
    document.querySelector('#avatar_screen').classList.remove('active2');
  }
}
